import { apiGet, apiPost, apiPut } from 'utils/http';

const subscriptionAPI = {
  fetchById: async ({ subscriptionId }) => {
    return (await apiGet(`/subscriptions/${subscriptionId}`)).subscription;
  },
  fetchPage: async ({
    page,
    pageSize,
    filters: { statuses, deliveryTypes, subscriptionPaymentMethods, ...restOfFilters },
  }) => {
    return apiGet(`/subscriptions`, {
      query: {
        offset: page * pageSize,
        pageSize,
        status: statuses,
        deliveryType: deliveryTypes,
        subscriptionPaymentMethod: subscriptionPaymentMethods,
        ...restOfFilters,
      },
    });
  },
  cancelSubscription: async ({ subscriptionId }) => {
    return apiPut(`/subscriptions/${subscriptionId}/cancel`);
  },
  async createOrderAndCardSubscription({ orderData, subscriptionConfig, storeCardConfig }) {
    return apiPost(`/subscriptions/cardSubscription`, {
      body: {
        orderData,
        subscriptionConfig,
        storeCardConfig,
      },
    });
  },
  async createOrderAndInvoiceSubscription({ orderData, subscriptionConfig, invoiceConfig }) {
    return apiPost(`/subscriptions/invoiceSubscription`, {
      body: {
        orderData,
        subscriptionConfig,
        invoiceConfig,
      },
    });
  },
  async updateOrderAndCardSubscription({ subscriptionId, orderData, subscriptionConfig }) {
    return apiPut(`/subscriptions/${subscriptionId}/card`, {
      body: {
        orderData,
        subscriptionConfig,
      },
    });
  },
  async updateOrderAndInvoiceSubscription({ subscriptionId, orderData, subscriptionConfig, invoiceConfig }) {
    return apiPut(`/subscriptions/${subscriptionId}/invoice`, {
      body: {
        orderData,
        subscriptionConfig,
        invoiceConfig,
      },
    });
  },
};

export { subscriptionAPI };
